module.exports = __webpack_public_path__ + "static/media/Formular-Black.ea255f23.woff2";